import { Injectable } from "@angular/core";
import { ConnectionStatusService } from "../connection-status/connection-status.service";
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { NETWORK_CHECK_ENDPOINT_BLACKLIST } from "src/app/config/errors";

@Injectable({
  providedIn: "root",
})
export class NetworkInterceptorService {
  constructor(private networkService: ConnectionStatusService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const startTime = performance.now();
    const skippedEndpoints = NETWORK_CHECK_ENDPOINT_BLACKLIST;

    if (skippedEndpoints.some((url) => req.url.includes(url))) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            if (
              !(
                event.status === HttpStatusCode.Ok ||
                event.status === HttpStatusCode.Created ||
                event.status === HttpStatusCode.NoContent
              )
            ) {
              return;
            }

            const latency = performance.now() - startTime;
            this.networkService.reportSuccess(latency);
          }
        },
      }),
    );
  }
}
